import { Link } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Alert, Button } from "@/shared/ui";

export const SomeSubscriptionsIssueAlert = () => {
  return (
    <Alert type="warning" className="border-yellow-500">
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="flex grow flex-col gap-1">
          <h6 className="font-semibold text-yellow-950">
            {t`There was an issue with some of your subscription payments`}
          </h6>
          <p>
            {t`You can still use your active subscriptions, but you won't receive medication or be charged for the affected ones until the issue is resolved.`}
          </p>
        </div>

        <Button
          asChild
          size="lg"
          className="-ml-6 sm:ml-0 sm:self-start lg:self-center"
        >
          <Link to={ROUTES.BILLING.OVERVIEW}>{t`Update payment`}</Link>
        </Button>
      </div>
    </Alert>
  );
};
